import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentContentBlock {
    export const ID = 'content-block';

    export interface IData extends NICmsContentComponent.IData {
        block: number;
    }
}
